/**
 * 导航栏左右区分标识 0:左边  1：右边
 */
export const STATUS = [0, 1]
